import React, { useEffect, useState } from "react";
import cogoToast from "cogo-toast";
import PublitioAPI from "publitio_js_sdk";
import ButtonPrimary from "components/Button/ButtonPrimary";
import Heading2 from "components/Heading/Heading2";
import ClipLoader from "react-spinners/ClipLoader";
import { BACKEND_URL } from "constants";

const PageGenerateArticles = () => {
  const [mode, setMode] = useState(false)
  const publitio = new PublitioAPI(
    "m7RBc51bBSJtDLyfn5ox",
    "D7e4hWupPLHs0wqpXQDNQy2kJ6vVQZWZ"
  );

  const [token, setToken] = useState("")

  const [autoMode, setAutoMode] = useState(false);
  const [papArticles, setPapArticles] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dateFrom, setDateFrom] = useState("")
  const [dateTo, setDateTo] = useState("")
  const [cat, setCat] = useState("")
  const [subcategory, setSubCategory] = useState("")

  const [sections, setSections] = useState([]);
  const [fotos, setFotos] = useState([]);
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedPhoto, setSelectedPhoto] = useState("");
  const [uploading, setUploading] = useState(false);
  const [loadingArticles, setLoadingArticles] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const userId = user?.user?.id || 16;

  // -----------------------------------------
  // POBIERZ SEKCJE I ZDJĘCIA
  // -----------------------------------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [secRes, fotoRes] = await Promise.all([
          fetch(`${BACKEND_URL}/sections`),
          fetch(`${BACKEND_URL}/fotos`),
        ]);

        const secData = await secRes.json();
        const fotoData = await fotoRes.json();

        setSections(secData);
        setFotos(fotoData);
      } catch (err) {
        console.error("Błąd przy pobieraniu sekcji/zdjęć:", err);
      }
    };

    fetchData();
  }, []);

  // -----------------------------------------
  // POBIERZ ARTYKUŁY PAP – backend sam robi całą robotę
  // -----------------------------------------
  const fetchPapArticles = async () => {
    try {
      setLoadingArticles(true);

      const res = await fetch(`${BACKEND_URL}/agent`,{ method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({dateFrom:dateFrom, dateTo: dateTo, cat:cat}) });
      const data = await res.json();

      if (data.articles?.length) {
        setPapArticles(data.articles);
        setSubCategory(data?.subcategory)
        setAutoMode(true);
        setCurrentIndex(0);
        cogoToast.success(`Pobrano ${data.articles.length} artykułów z PAP.`);
      } else {
        cogoToast.info("Brak nowych artykułów.");
      }
    } catch (err) {
      console.error(err);
      cogoToast.error("Błąd podczas pobierania artykułów.");
    } finally {
      setLoadingArticles(false);
    }
  };

  const updateToken = async () => {
    try{
      const res = await fetch(`${BACKEND_URL}/update-pap-token`, {
        method: "POST",
        body:JSON.stringify({token: token}),
        headers: { "Content-Type": "application/json" },
      });

      const data = await res.json();

      if (data.status === "ok") {
        cogoToast.success(`Token zaaktualizowany`);
        setMode(true)
        setToken("")
      } else {
        cogoToast.error("Nie udało się pobrać tokena");
      }
    } catch (err) {
      console.error(err);
      cogoToast.error("Błąd podczas zapisu artykułu.");
    }
  }

  // -----------------------------------------
  // UPLOAD NOWEGO ZDJĘCIA
  // -----------------------------------------
  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const res = await publitio.uploadFile(file, "file", { folder: "pap" });
      setSelectedPhoto(res.url_preview);
      cogoToast.success("Zdjęcie przesłane!");
    } catch (err) {
      console.error(err);
      cogoToast.error("Błąd przesyłania zdjęcia.");
    } finally {
      setUploading(false);
    }
  };

  // -----------------------------------------
  // ZAPISZ ARTYKUŁ
  // -----------------------------------------
  const handleSaveArticle = async (article) => {
    if (!selectedSection) return cogoToast.warn("Wybierz sekcję!");
    // if (!selectedPhoto) return cogoToast.warn("Wybierz lub dodaj zdjęcie!");

    try {
      const payload = {
        ...article,
        section_id: selectedSection,
        image: selectedPhoto,
        subcategory: subcategory,
        user_id: userId,
      };

      const res = await fetch(`${BACKEND_URL}/generate-article`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status === "ok") {
        cogoToast.success(`Artykuł "${article.title}" dodany.`);
        setCurrentIndex((prev) => prev + 1);
        setSelectedPhoto("");
        setSelectedSection("");
      } else {
        cogoToast.error("Nie udało się zapisać artykułu.");
      }
    } catch (err) {
      console.error(err);
      cogoToast.error("Błąd podczas zapisu artykułu.");
    }
  };

  const processAllArticles = async () => {

  for (let i = 0; i < papArticles.length; i++) {
    const article = papArticles[i];

    const payload = {
      ...article,
      section_id: 9,
      user_id: userId,
    };

    try {
      const res = await fetch(`${BACKEND_URL}/generate-article`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status === "ok") {
        cogoToast.success(`Dodano: ${article.title}`);
      } else {
        cogoToast.error(`Błąd dodawania: ${article.title}`);
      }
    } catch (err) {
      console.error(err);
      cogoToast.error(`Błąd: ${article.title}`);
    }
  }

  cogoToast.success("🎉 Wszystkie artykuły zostały dodane!");
};


  // -----------------------------------------
  // RENDER
  // -----------------------------------------
  return (
    <>
      <header className="text-center max-w-2xl mx-auto mb-10">
        <Heading2>Wygeneruj artykuły z PAP</Heading2>

        <div className="mt-4">
          <input placeholder="Wpisz nowy token" onChange={(e) => setToken(e.target.value)} value={token} type="text"/>
            <ButtonPrimary onClick={updateToken}>
            Zaaktualizuj token
          </ButtonPrimary>
           Od: <input style={{marginTop:"10px", marginBottom:"10px"}} onChange={(e) => setDateFrom(e.target.value)} value={dateFrom} type="date"/>
           <br></br>
           Do: <input style={{marginTop:"0px", marginBottom:"10px"}} onChange={(e) => setDateTo(e.target.value)} value={dateTo} type="date"/>
           <br></br>
           Kategoria: <select onChange={(e) => setCat(e.target.value) }>
            <option value="">Brak</option>
            <option value="110">Polityka</option>
            <option value="15">Sport</option>
           </select>
            {/* <ButtonPrimary onClick={updateToken}></ButtonPrimary> */}
          <ButtonPrimary onClick={fetchPapArticles} disabled={loadingArticles}>
            {loadingArticles ? "Pobieranie..." : "Pobierz artykuły z PAP"}
          </ButtonPrimary>
         {/* <ButtonPrimary
  onClick={processAllArticles}
  disabled={papArticles.length === 0}
  className="mt-3"
>
  Dodaj wszystkie artykuły automatycznie
</ButtonPrimary>  */}

          <button
                  onClick={() => setCurrentIndex((prev) => prev + 1)}
                  className="px-4 py-2 rounded-lg border border-neutral-400 text-neutral-600 hover:bg-neutral-100 transition"
                >
                  Pomiń
                </button>

          {loadingArticles && (
            <div className="mt-3 flex justify-center">
              <ClipLoader size={32} />
            </div>
          )}
        </div>
      </header>

      <div className="max-w-4xl mx-auto space-y-6">
        {autoMode &&
          papArticles.length > 0 &&
          currentIndex < papArticles.length && (
            <div className="bg-neutral-100 p-6 rounded-xl shadow">
              <h3 className="font-semibold text-lg mb-2">
                {papArticles[currentIndex].title}
              </h3>

              <p className="text-sm text-neutral-600 mb-4">
                {papArticles[currentIndex].description}
              </p>

             <p style={{fontSize:"12px"}} dangerouslySetInnerHTML={{
    __html: papArticles[currentIndex]?.long_description || ""
  }}
  className="text-sm text-neutral-600 mb-4"
/>

              <p className="text-sm text-neutral-600 mb-4">
                {papArticles[currentIndex].country === "POL"
                  ? "Kraj"
                  : "Świat"}
              </p>

              {/* SEKCJE */}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Wybierz sekcję:
                </label>

                <select
                  className="w-full border rounded-lg p-2"
                  value={selectedSection}
                  onChange={(e) => setSelectedSection(e.target.value)}
                >
                  <option value="">-- Wybierz sekcję --</option>
                  {sections.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.sectionName}
                    </option>
                  ))}
                </select>
              </div>

              {/* GALERIA */}
              <div className="mb-6">
                <label className="block text-sm font-medium mb-2">
                  Wybierz zdjęcie z bazy:
                </label>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                  {fotos.map((foto) => (
                    <div
                      key={foto.id}
                      onClick={() => setSelectedPhoto(foto.foto_link)}
                      className={`relative cursor-pointer border-2 rounded-lg overflow-hidden ${
                        selectedPhoto === foto.foto_link
                          ? "border-blue-500"
                          : "border-transparent"
                      }`}
                    >
                      <img
                        src={foto.foto_link}
                        alt={foto.foto_title}
                        className="object-cover w-full h-32"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-white text-xs p-1 text-center truncate">
                        {foto.foto_title}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="text-center mt-4 text-sm text-neutral-600">
                  lub dodaj nowe zdjęcie
                </div>

                <input
                  type="file"
                  accept="image/*"
                  className="mt-2"
                  onChange={handleUpload}
                />

                {uploading && <ClipLoader size={24} />}

                {selectedPhoto && (
                  <div className="mt-3 text-center">
                    <p className="text-sm text-neutral-700 mb-1">
                      Podgląd wybranego zdjęcia:
                    </p>
                    <img
                      src={selectedPhoto}
                      alt="Podgląd"
                      className="rounded-lg max-h-64 mx-auto"
                    />
                  </div>
                )}
              </div>

              {/* PRZYCISKI */}
              <div className="flex justify-end gap-3">

                <ButtonPrimary
                  onClick={() =>
                    handleSaveArticle(papArticles[currentIndex])
                  }
                >
                  Zatwierdź i przejdź dalej
                </ButtonPrimary>
              </div>

              <p className="text-xs text-neutral-500 mt-3 text-center">
                Artykuł {currentIndex + 1} z {papArticles.length}
              </p>
            </div>
          )}

        {autoMode && currentIndex >= papArticles.length && (
          <div className="text-center text-green-600 font-semibold">
            ✅ Wszystkie artykuły zostały przetworzone!
          </div>
        )}
      </div>
    </>
  );
};

export default PageGenerateArticles;
